module.exports = __webpack_public_path__ + "img/8_72.775f71c3.png";